import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useFeatureFlag(flagKey: string) {
  const { data, isLoading } = useQuery({
    queryKey: ["feature_flag", flagKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("feature_flags")
        .select("enabled")
        .eq("flag_key", flagKey)
        .maybeSingle();
      if (error) throw error;
      return data?.enabled ?? false;
    },
    staleTime: 60_000,
  });
  return { enabled: !!data, isLoading };
}
